<script>
  import { onDestroy } from 'svelte';
  import Button from '@components/Button.svelte';
  import Input from '@components/Input.svelte';
  import Text from '@components/Text.svelte';
  import Modal from '@components/Modal.svelte';
  import PreloadBox from '@components/PreloadBox.svelte';
  import Rating from '@utils/rating';
  import AffiliateUrl from '@utils/affiliate_url';
  import { getGroupStore } from '@stores/group';
  let configStore = getGroupStore('configStore');
  import { values } from 'lodash-es';
  import ConfigAjax from '@ajax/config';

  import tippy from 'tippy.js';

  import Photos from '@app-components/rec_object/parts/Photos.svelte';
  import RatingViewer from '@app-components/rec_object/parts/Rating.svelte';

  export let result;
  export let resultImages;
  export let mobile = false;
  export let clearCard;
  export let currentUser;
  export let affiliateLinkEnabled = false;
  export let loadingData = false;
  export let loadingPreview = false;
  export let ratingWebResult;
  export let updateImageDisplayStyle;
  export let startPosition = 0;

  let config = configStore;
  let unsub = config.subscribe((x) => (config = x));

  if (!config.ratings) {
    ConfigAjax.group().then((resp) => {
      configStore.set(resp);
    });
  }

  import jQuery from 'jquery';

  let showReviewModal = false;

  let newSiteUrl;
  let newScore;
  let unsupportedRating = false;

  let updatingRating = false;

  let address = '';
  let autocomplete;
  let inputEl;

  let hasValidRating = false;
  export let ratingShown = false;

  let loaderSequenceShown = false;
  let loaderSequencePulsing = false;
  let showName1Loader = false;
  let showRatingLoader = false;
  let showPhotoLoader = false;

  let name1LoaderTimer;
  let ratingLoaderTimer;
  let photoLoaderTimer;
  let pulseTimer;

  $: if (result) {
    if (!result.selectedRating) {
      computeRating();
    }
  }

  $: {
    if (loadingPreview) {
      loaderSequenceShown = false;
      loaderSequencePulsing = false;
      showName1Loader = false;
      showRatingLoader = false;
      showPhotoLoader = false;

      [name1LoaderTimer, ratingLoaderTimer, photoLoaderTimer, pulseTimer].forEach((timer) => {
        clearTimeout(timer);
      });

      startShowLoaderSequence();
    }
  }

  $: if (result && result.address && result.address.length > 0 && result.address[0].address) {
    address = result.address[0].address;
  } else {
    address = '';
  }

  const startShowLoaderSequence = () => {
    if (loaderSequenceShown) {
      return;
    }

    loaderSequenceShown = true;
    const delayMs = 600; // ms between loading things

    name1LoaderTimer = setTimeout(() => (showName1Loader = true), delayMs * 2);
    ratingLoaderTimer = setTimeout(() => (showRatingLoader = true), delayMs * 3);
    photoLoaderTimer = setTimeout(() => (showPhotoLoader = true), delayMs * 4);
    pulseTimer = setTimeout(() => (loaderSequencePulsing = true), delayMs * 6);
  };

  let clearAddress = function () {
    jQuery(inputEl).val('');
  };

  let attachKeyPressListenerToAutocomplete = function (inputEl) {
    var _addEventListener = inputEl.addEventListener ? inputEl.addEventListener : inputEl.attachEvent;

    function addEventListenerWrapper(type, listener) {
      // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
      // and then trigger the original listener.
      if (type == 'keydown') {
        var orig_listener = listener;
        listener = function (event) {
          var suggestion_selected = jQuery('.pac-item-selected').length > 0;
          if ((event.which == 13 || event.which == 9) && !suggestion_selected) {
            var simulated_downarrow = jQuery.Event('keydown', {
              keyCode: 40,
              which: 40,
            });
            orig_listener.apply(inputEl, [simulated_downarrow]);
          }

          orig_listener.apply(inputEl, [event]);
        };
      }

      _addEventListener.apply(inputEl, [type, listener]);
    }

    inputEl.addEventListener = addEventListenerWrapper;
    inputEl.attachEvent = addEventListenerWrapper;
  };

  let isBadAddress = false;
  let autocompleteBlurTimeout;
  let setupAutocomplete = function (node) {
    let setupInterval;

    if (typeof google !== 'undefined' && google.maps && !google.maps.places) {
      google.maps.importLibrary('places');
    }

    setupInterval = setInterval(() => {
      if (typeof google !== 'undefined' && google.maps && google.maps.places && google.maps.places.Autocomplete) {
        clearInterval(setupInterval);
        inputEl = jQuery(node).children('input')[0];
        attachKeyPressListenerToAutocomplete(inputEl);

        autocomplete = new google.maps.places.Autocomplete(inputEl, {
          types: ['geocode'],
        });

        inputEl.addEventListener('change', () => {
          isBadAddress = false;
          autocompleteBlurTimeout = setTimeout(() => {
            isBadAddress = true;
            updateAddress('');
          }, 500);
        });

        google.maps.event.addListener(autocomplete, 'place_changed', () => {
          clearInterval(autocompleteBlurTimeout);
          let place = autocomplete.getPlace();
          updateAddress(place.formatted_address);
        });

        setTimeout(() => {
          jQuery(inputEl).prop('autocomplete', 'new-password');
        }, 500);
      }
    }, 100);
  };

  let handleAddressFieldBlur = function () {
    if (this.value === '') {
      result.address = [];
    }
  };

  let computeRating = function () {
    let website = result.searchSource === 'url' ? result.website : null;
    let selected = Rating.findBestRatingToShow(values(result.rating), configStore, currentUser, website);

    if (selected && selected.rating && selected.site_url) {
      result.selectedRating = selected;
      newSiteUrl = selected.site_url;
      newScore = selected.rating;
      hasValidRating = true;
    }
  };

  let updateRating = async function () {
    if (updatingRating) {
      return;
    }

    unsupportedRating = false;
    updatingRating = true;

    hasValidRating = !!Rating.configDataForRating({ site_url: newSiteUrl }, config);

    if (newSiteUrl === '') {
      result.selectedRating = {};
    } else {
      if (!hasValidRating) {
        unsupportedRating = true;
        updatingRating = false;
        return;
      }

      if (newScore > 5) {
        newScore = 5;
      } else if (newScore < 0) {
        newScore = 0;
      }

      let isAffiliate = false;

      if (currentUser && currentUser.affiliate_links_enabled) {
        isAffiliate = (await AffiliateUrl.testUrl(newSiteUrl)).is_affiliate;
      }

      result.selectedRating = {
        rating: newScore,
        site_url: newSiteUrl,
        number_of_reviews: 0,
        is_affiliate: isAffiliate,
      };
    }

    result = result;
    updatingRating = false;
    closeReviewModal();
  };

  let updateName1 = function (value) {
    result.name1 = value;
  };

  let updateAddress = function (value) {
    result.address = [
      {
        address: value,
      },
    ];
  };

  let displayReviewModal = function () {
    showReviewModal = true;
  };

  let closeReviewModal = function () {
    showReviewModal = false;
  };

  let setupTippy = function (node) {
    tippy(node);
  };

  let setupTippyWithDelay = function (node) {
    tippy(node, {
      delay: [1000, 0],
    });
  };

  let updatePhotoDisplayTooltip = function (element) {
    let newTooltipContent = element.getAttribute('data-tippy-content') == 'Expand photo' ? 'Fit photo' : 'Expand photo';
    setTimeout(() => {
      element?._tippy?.setContent(newTooltipContent);
    }, 120);
  };

  onDestroy(() => {
    unsub && unsub();
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';
  .rec-object-preview {
    .clear-card {
      display: flex;
      font-size: 14px;

      .clear-card-link {
        flex-shrink: 0;
        margin-left: 10px;
        cursor: pointer;
        font-weight: 500;

        &:hover {
          color: #7054dc;
        }
      }
    }

    .rec-object-card {
      margin-top: 16px;
      background: white;
      box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.0938593);
      padding: 30px;
      border-radius: 16px;

      .top-bar {
        display: flex;
        flex-direction: row-reverse;
        max-height: 35px;
        min-height: 35px;

        .categories {
          flex: 1;
          margin-right: 20px;

          :global(.editable-content) {
            color: #8e71ff;
            font-weight: 500;
            cursor: pointer;
            font-size: 16px;
            line-height: 22px;
            flex-shrink: 0;

            &:focus:empty:before {
              content: 'e.g. Florist, stroller, book, etc' !important;
            }

            &:hover {
              color: #7054dc;
            }

            &:empty:before {
              color: #8e71ff !important;
              opacity: 0.7 !important;
            }
          }
        }

        .review-site {
          margin-right: -10px;

          .add-review {
            cursor: pointer;
            font-size: 16px;
            line-height: 22px;
            color: #7f7f7f;
            opacity: 0.6;
            flex-shrink: 0;

            &:hover {
              color: #7054dc;
            }
          }
        }
      }

      .middle-bar {
        margin-top: 24px;

        .name1 {
          font-weight: 500;
          font-size: 24px;
          line-height: 32px;
        }

        .name1-with-rating {
          width: calc(100% - 130px);
        }

        .name2 {
          margin-top: 12px;
        }

        .neighborhood-container {
          min-height: 40px;
          display: flex;
          align-items: center;
          margin-top: 12px;

          svg {
            margin-top: -3px;
          }

          .neighborhood {
            color: black;
            opacity: 0.5;
            font-size: 15px;
            padding-left: 10px;
            padding-right: 10px;
            margin-top: 3px;
            width: 100%;

            .neighborhood-input {
              border: 2px solid transparent;
              width: 100%;
              border-radius: 7px;
              cursor: text;

              &:focus {
                border-color: #a893f9;
                background: #ede9ff;
                caret-color: #a893f9;
                outline: none;
              }

              &:hover {
                background-color: #ede9ff;
                outline: none;
                caret-color: #a893f9;
              }
            }
          }
        }

        .photos {
          margin-top: -12px;

          :global(.ui-single-photo .ui-photo) {
            width: 432px;
          }

          :global(.ui-photos:not(.is-mobile)) {
            width: calc(100% + 30px);
          }

          :global(.ui-photos .add-rec-object-photo) {
            height: 160px;
            width: 200px;
            margin-right: 0px;
          }

          :global(.ui-photos .style-icon-wrapper) {
            width: 200px;
            margin: 0 auto;
          }

          :global(.ui-photos .add-rec-object-photo-wrapper) {
            margin-right: 18px;
          }
        }
      }
    }

    .rating-container {
      height: 70px;
      cursor: pointer;
      padding: 5px;
      border-radius: 12px;
      position: relative;
      margin-top: -7px;

      .circle-dollar {
        position: absolute;
        top: 9px;
        left: -24px;
      }

      .ui-rating {
        display: flex;
        justify-content: flex-end;

        .ui-star {
          margin-left: 4px;
        }
      }

      &:hover {
        background: #eae4ff;
      }
    }

    .rating-preloader {
      height: 40px;
      width: 125px;
    }

    .address-preloader {
      padding-left: 16px;
      height: 8px;
      width: 90%;
    }
  }

  .add-rec-object-photo-wrapper:hover {
    .style-icon {
      display: block;
    }
  }
  .style-icon {
    height: 24px;
    width: 24px;
    position: absolute;
    right: 8px;
    top: 8px;
    display: none;
    filter: drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 5px);
  }

  .style-icon-wrapper {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 0px;
    position: relative;
  }

  .add-rec-object-photo-wrapper {
    .contain {
      border: 1px solid $neutral-input-gray;
    }
  }

  .mobile {
    .rec-object-card {
      min-height: 430px;
      padding: 20px;

      .top-bar {
        .categories {
          margin-right: 0px;
        }
      }

      .middle-bar {
        margin-top: 10px;

        .name1 {
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
        }

        .name1-with-rating {
          width: 100%;
        }

        .name2 {
          font-size: 16px;
          line-height: 22px;
          margin-top: 5px;
        }

        .review-site {
          margin-top: 20px;
          position: relative;
          display: inline-flex;
          align-items: center;

          .circle-dollar {
            margin-left: 20px;
          }

          .add-review {
            opacity: 0.6;
          }

          .rating-container {
            margin-top: 0px;

            .circle-dollar {
              right: 0px;
            }

            .ui-rating {
              justify-content: flex-start;

              .ui-star {
                margin-right: 4px;
                margin-left: 0px;
              }
            }

            .rating-svg {
              float: left !important;
              margin-top: 10px !important;
            }
          }

          .rating-preloader {
            height: 30px;
          }
        }

        .address-preloader {
          width: 200px;
        }
        .photos {
          :global(.ui-single-photo .add-rec-object-photo) {
            width: 250px !important;
            height: 163px !important;
            margin-right: inherit;
            margin: 0 auto;
            border-radius: 15px;
          }

          :global(.ui-photos .add-rec-object-photo) {
            width: 250px !important;
            height: 163px !important;
            margin-right: inherit;
            margin: 0 auto;
            border-radius: 15px;
          }

          :global(.ui-photos .style-icon-wrapper) {
            width: 250px !important;
            margin: 0 auto;
          }

          // this cutoff is set in DetailViewModal, seems custom for tablet for this modal
          @media only screen and (max-width: 640px) {
            :global(.ui-photos .add-rec-object-photo-wrapper) {
              margin-right: 0px;
            }
          }
        }
      }
    }

    .m-placeholder-categories {
      max-width: 100%;
      width: 120px;
      height: 40px;
    }

    .m-placeholder-name1 {
      margin-top: 24px;
      max-width: 100%;
      width: 295px;
      height: 40px;
      margin-bottom: 40px;
    }

    .m-placeholder-rating-address {
      max-width: 100%;
      width: 216px;
      height: 40px;
      margin-bottom: 48px;
    }

    .m-placeholder-photos {
      max-width: 100%;
      width: 295px;
      height: 216px;
    }

    .style-icon {
      display: block;
      z-index: 10;
    }
  }
</style>

<div class="svelte-modal">
  <Modal mobile={mobile} bind:show={showReviewModal} style="width: 350px">
    <div slot="content">
      <div style="display: flex; align-items: center">
        <div style="width: 216px">
          <div style="font-size: 12px; line-height: 16px; margin-bottom: 10px;">
            <span style="opacity: 0.5">Review site link</span>
            {#if affiliateLinkEnabled && result && result.selectedRating && result.selectedRating.is_affiliate && newSiteUrl == result.selectedRating.site_url}
              <img
                data-tippy-content="Affiliate Link ON"
                use:setupTippy
                src="/images/payout/circle-dollar.svg"
                style="margin-left: 6px; margin-top: -2px;" />
            {/if}

            {#if newSiteUrl || newScore}
              <a
                style="color: red; opacity: 1; float: right; cursor: pointer; font-weight: 900; opacity: 0.5;"
                on:click={() => {
                  newSiteUrl = '';
                  newScore = '';
                }}>Clear</a>
            {/if}
          </div>
          <div>
            <Input on:enter={updateRating} bind:value={newSiteUrl} focusAtFront={true} />
          </div>
        </div>
        <div style="margin-left: 16px; width: 76px;">
          <div
            style="font-size: 12px;
          line-height: 16px; opacity: 0.5; margin-bottom: 10px;">
            Rating
          </div>
          <div>
            <Input
              on:enter={updateRating}
              bind:value={newScore}
              type="number"
              inputStyle="padding-left: 10px; padding-right: 10px; text-align: center;"
              inputProps={{ max: 5, min: 0 }} />
          </div>
        </div>
      </div>

      {#if unsupportedRating}
        <div style="margin-top: 20px; font-size: 13px; line-height: 19px; color: #FF5567;">
          <div style="font-weight: bold">Currently supported review sites:</div>
          <div style="margin-top: 1px;">
            {config.ratings.map((x) => x.name).join(', ')}
          </div>
        </div>
      {/if}

      <div style="margin-top: 30px; display: flex; justify-content: center;">
        <Button
          on:click={updateRating}
          text={updatingRating
            ? '<i class="fa fa-spinner fa-spin"></i><span style="margin-left: 12px;">Saving</span>'
            : 'Confirm'}
          style="width: {updatingRating ? '112px' : '89px'}; height: 48px; margin-top: 0px; margin-bottom: 0px;" />
      </div>
    </div>
  </Modal>
</div>

<div class="rec-object-preview" class:mobile={mobile}>
  <div class="clear-card">
    <div style="flex: 1">Card preview</div>
    <div
      class="clear-card-link"
      on:click={() => {
        clearCard();
        clearAddress();
      }}>
      Clear card
    </div>
  </div>

  <div class="rec-object-card">
    {#if !mobile}
      <div class="top-bar">
        <div class="review-site">
          {#if hasValidRating}
            <div class="rating-container">
              {#if ratingShown && result && result.selectedRating && result.selectedRating.is_affiliate && affiliateLinkEnabled}
                <img
                  data-tippy-content="Affiliate Link ON"
                  use:setupTippy
                  src="/images/payout/circle-dollar.svg"
                  class="circle-dollar" />
              {/if}

              {#if !ratingShown}
                <div class="add-review" on:click={displayReviewModal}>Add review site</div>
              {/if}

              <RatingViewer
                bind:shown={ratingShown}
                ratingWebResult={ratingWebResult}
                forceShowRating={true}
                recObjectRating={result.selectedRating}
                trackThenGoToRating={displayReviewModal} />
            </div>
          {:else if loadingData}
            <div class="rating-preloader"><PreloadBox moving={false} /></div>
          {:else}
            <div class="add-review" on:click={displayReviewModal}>Add review site</div>
          {/if}
        </div>
      </div>
    {/if}

    <div class="middle-bar">
      {#if mobile && !result}
        {#if showName1Loader}
          <div class="m-placeholder-name1"><PreloadBox moving={loaderSequencePulsing} /></div>
        {/if}
      {:else}
        <div class="name1" class:name1-with-rating={hasValidRating}>
          {#key result.name1}
            <Text
              on:blur={(e) => {
                updateName1(e.detail.text);
              }}
              lines={mobile ? 2 : 1}
              useAutoLinker={false}
              style="width: 100%;"
              text={result.name1}
              editable={true}
              placeholder={'Add name'} />
          {/key}
        </div>
      {/if}

      {#if mobile}
        {#if result}
          <div class="review-site" on:click={displayReviewModal}>
            {#if hasValidRating}
              <RatingViewer
                bind:shown={ratingShown}
                ratingWebResult={ratingWebResult}
                forceShowRating={true}
                recObjectRating={result.selectedRating}
                trackThenGoToRating={displayReviewModal}
                mobile={true}
                displayStyle="inline" />

              {#if ratingShown && result && result.selectedRating && result.selectedRating.is_affiliate && affiliateLinkEnabled}
                <img src="/images/payout/circle-dollar.svg" class="circle-dollar" />
              {/if}

              {#if !ratingShown}
                <div class="add-review" on:click={displayReviewModal}>Add review site</div>
              {/if}
            {:else if loadingData}
              <div class="rating-preloader"><PreloadBox moving={false} /></div>
            {:else}
              <div class="add-review">Add review site</div>
            {/if}
          </div>
        {/if}
      {/if}

      {#if result}
        <div class="neighborhood-container">
          <svg
            style="flex-shrink: 0; cursor: pointer;"
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7 17C7 17 14 12.4667 14 6.8C14 3.04446 10.866 0 7 0C3.13401 0 0
        3.04446 0 6.8C0 12.4667 7 17 7 17ZM9.33341 6.79999C9.33341 8.05184
        8.28875 9.06666 7.00008 9.06666C5.71142 9.06666 4.66675 8.05184
        4.66675 6.79999C4.66675 5.54815 5.71142 4.53333 7.00008
        4.53333C8.28875 4.53333 9.33341 5.54815 9.33341 6.79999Z"
              fill="#D5CFEA" />
          </svg>
          {#if address?.length || !loadingData}
            <div class="neighborhood" use:setupAutocomplete>
              <input
                autocomplete="new-password"
                type="text"
                class="neighborhood-input"
                value={address}
                placeholder={'Add address'}
                on:blur={handleAddressFieldBlur} />
            </div>
          {:else}
            <div class="address-preloader"><PreloadBox /></div>
          {/if}
        </div>

        {#if isBadAddress}
          <div style="font-size: 80%; color: #dc3545; margin-left: 32px; margin-top: -5px;">Address is invalid</div>
        {/if}
      {:else if showRatingLoader}
        <div class="m-placeholder-rating-address"><PreloadBox moving={loaderSequencePulsing} /></div>
      {/if}

      <div class="photos">
        {#if mobile}
          {#if !result}
            {#if showPhotoLoader}
              <div class="m-placeholder-photos"><PreloadBox moving={loaderSequencePulsing} /></div>
            {/if}
          {:else}
            <Photos
              mobile={mobile}
              extraIdentifier="add-rec-object-preview"
              startPosition={startPosition}
              photos={resultImages.map((i, index) => {
                return {
                  id: index,
                  lowRes: i.lowRes,
                  display_style: i.display_style,
                  view_urls: i.view_urls || {
                    full_size: i.src,
                    rect_size: i.src,
                    square_size: i.src,
                  },
                };
              })}>
              <div slot="img" let:photo let:index let:currentIndex>
                <div class="add-rec-object-photo-wrapper">
                  <div class="style-icon-wrapper">
                    <img
                      class="style-icon"
                      alt="style-icon"
                      on:mousedown|preventDefault|stopPropagation={() => updateImageDisplayStyle(index, currentIndex)}
                      on:touchstart|preventDefault|stopPropagation={() => updateImageDisplayStyle(index, currentIndex)}
                      on:click|preventDefault|stopPropagation
                      src={photo.display_style == 'contain'
                        ? '/images/rec_request/expand-icon.svg'
                        : '/images/rec_request/fit-icon.svg'} />
                  </div>
                  <img
                    class="add-rec-object-photo ui-photo {photo.display_style}"
                    src={photo.view_urls.rect_size || photo.view_urls.full_size} />
                </div>
              </div>
            </Photos>
          {/if}
        {:else}
          <Photos
            extraIdentifier="add-rec-object-preview"
            startPosition={startPosition}
            photos={resultImages.map((i, index) => {
              return {
                id: index,
                lowRes: i.lowRes,
                display_style: i.display_style,
                view_urls: i.view_urls || {
                  full_size: i.src,
                  rect_size: i.src,
                  square_size: i.src,
                },
              };
            })}>
            <div slot="img" let:photo let:index let:currentIndex>
              <div class="add-rec-object-photo-wrapper">
                {#if photo && photo.view_urls && photo.view_urls.full_size && !photo.view_urls.full_size.startsWith('/images/placeholder-square.png')}
                  <div class="style-icon-wrapper">
                    <img
                      data-tippy-content={photo.display_style == 'contain' ? 'Expand photo' : 'Fit photo'}
                      use:setupTippyWithDelay
                      class="style-icon"
                      alt="style-icon"
                      on:mousedown|preventDefault|stopPropagation={(event) => {
                        updateImageDisplayStyle(index, currentIndex);
                        updatePhotoDisplayTooltip(event.currentTarget);
                      }}
                      on:click|preventDefault|stopPropagation
                      src={photo.display_style == 'contain'
                        ? '/images/rec_request/expand-icon.svg'
                        : '/images/rec_request/fit-icon.svg'} />
                  </div>
                {/if}
                <img
                  class="add-rec-object-photo ui-photo {photo.display_style}"
                  src={photo.view_urls.rect_size || photo.view_urls.full_size} />
              </div>
            </div>
          </Photos>
        {/if}
      </div>
    </div>
  </div>
</div>
